<template>
    <main class="signup-form supalytic-bg pt-1">
    <div class="container">
        <div class="row justify-content-center m-0">
            <div class="col-md-4">

                <div class="card mt-3">
                  <div class="card-body">

                    <div class="text-center pt-1 pb-2">
                    <img src="/images/supalytic-b.svg" width="150" alt="Supalytic">
                </div>
                
        <div class="card mt-3 mb-0 py-2 px-3 text-center" 
        style="background:#000;color:#fff;border:none !important;border-radius:5px !important;">Please answer the question to proceed</div>

                <div class="card mt-3 mb-2">
                <div class="card-header normal">What is {{num_1}} + {{num_2}}</div>
                    <div class="card-body">

                  <div class="alert alert-danger text-center" role="alert" v-if="error_message">
                        <span v-html="error_message"></span>
                    </div>
                    
                    <div class="alert alert-success mb-0 text-center" role="alert" v-if="success_message">
                        <span v-html="success_message"></span>
                    </div>

                    <div v-if="!submitted"> 
                      <div class="form-group mb-3">
                        <input id="submitted_answer" type="number" placeholder="Type answer here" class="form-control2" name="submitted_answer" v-model="submitted_answer">
                      </div>

                        <div class="d-grid mx-auto">
                          <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin fa-1x"></i></div>
                          <button v-else type="submit" class="btn btn-success btn-block" @click="submitForm">Let me in</button>
                        </div>
                    </div>

                    </div>
                </div>

                  </div>
                </div>

            </div>
        </div>
    </div>
</main>
</template>

<script>
export default {

  data() {
    return {
      submitted_answer: null,
      error_message: null,
      success_message: null,
      loading: false,
      showPassword: false,
      submitted: false,
      num_1: Math.floor(Math.random() * 10) + 1,
      num_2: Math.floor(Math.random() * 10) + 1,
      correct_answer: null
    };
  },

  created() {
    this.correct_answer = this.num_1 + this.num_2;
  },

  methods: {

      submitForm() {

          this.error_message = null;
          this.success_message = null;

          if (!this.submitted_answer || this.submitted_answer=='') { this.sweetfire('Please enter answer to proceed')}

          else {

          this.loading = true;

          axios
          .post('/security-post', {
            correct_answer: this.correct_answer,
            submitted_answer: this.submitted_answer
            })
          .then((response) => {
            
            if(response.data.success) {
              window.location.href = response.data.url;
            
            } else {
              this.error_message = response.data.message;
              this.loading = false;
            }
            

          });

          }
      },


    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

  },
};

</script> 

<style>

</style>